import React, { useEffect, useState, useRef } from 'react';
interface FadeInProps {
  children: React.ReactNode;
  delay?: number;
  direction?: 'up' | 'down' | 'left' | 'right' | 'none';
  className?: string;
}
export function FadeIn({
  children,
  delay = 0,
  direction = 'up',
  className = ''
}: FadeInProps) {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) {
      // Fallback: just show it
      const t = setTimeout(() => setVisible(true), delay * 1000 + 100);
      return () => clearTimeout(t);
    }
    // Use IntersectionObserver if available, otherwise just show with delay
    if (typeof IntersectionObserver !== 'undefined') {
      const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            setTimeout(function () {
              setVisible(true);
            }, delay * 1000);
            observer.unobserve(el);
          }
        });
      }, {
        rootMargin: '-50px'
      });
      observer.observe(el);
      return function () {
        observer.unobserve(el);
      };
    } else {
      // No IntersectionObserver — show after delay
      var t = setTimeout(function () {
        setVisible(true);
      }, delay * 1000 + 200);
      return function () {
        clearTimeout(t);
      };
    }
  }, [delay]);
  var translate = 'translateY(20px)';
  if (direction === 'down') translate = 'translateY(-20px)';
  if (direction === 'left') translate = 'translateX(20px)';
  if (direction === 'right') translate = 'translateX(-20px)';
  if (direction === 'none') translate = 'none';
  return <div ref={ref} className={className} style={{
    opacity: visible ? 1 : 0,
    transform: visible ? 'none' : translate,
    transition: 'opacity 0.6s ease-out, transform 0.6s ease-out'
  }} data-id="element-146">
      {children}
    </div>;
}